
<!--
~ VNCtask : VNCtask – the easy to use Task Management & To-Do List application. Stay organized. Anytime! Anywhere!
~ Copyright (C) 2015-2020 VNC – Virtual Network Consult AG (info@vnc.biz)
~
~ This program is free software: you can redistribute it and/or modify
~ it under the terms of the GNU Affero General Public License as published by
~ the Free Software Foundation, version 3 of the License.
~
~ This program is distributed in the hope that it will be useful,
~ but WITHOUT ANY WARRANTY; without even the implied warranty of
~ MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
~ GNU Affero General Public License for more details.
~
~ You should have received a copy of the GNU Affero General Public License
~ along with this program. Look for COPYING file in the top folder.
~ If not, see http://www.gnu.org/licenses/.
-->

<div id="advance-search-dialog" class="advance-search-dialog task__dialog">
  <div class="task__dialog-header">
    <div class="mobile-back-button">
      <button matButton (click)="close()">
        <mat-icon class="disable-select">close</mat-icon>
      </button>
    </div>
    <div class="header_lbl disable-select">
      {{'ADVANCED_SEARCH' | translate}}
    </div>
    <div class="desktop-close-button">
      <button matButton (click)="clear()">
        <mat-icon class="disable-select">cached</mat-icon>
      </button>
      <button matButton (click)="close()">
        <mat-icon class="disable-select">close</mat-icon>
      </button>
    </div>
    <div class="mobile-back-button">
      <button matButton (click)="clear()">
        <mat-icon class="disable-select">cached</mat-icon>
      </button>
    </div>
  </div>
  <div class="mat-dialog__content-block task__dialog-body">
    <div class="advance-search-list">

      <mat-list role="list">
        <mat-list-item role="listitem" class="app-container" (click)="redirectTo('apps')">
          <div>
            <div>{{ 'SEARCH_IN_APPS' | translate }}</div>
            @if (advanceSearch.app_types.length === 6) {
              <div class="sub-title">{{ 'ALL_APPS' | translate }}</div>
            }
            @if (advanceSearch.app_types.length < 6) {
              <div class="sub-title">{{ getAppsTitle() }}</div>
            }
          </div>
        </mat-list-item>

        <mat-list-item role="listitem" class="app-container" (click)="redirectTo('search-through')">
          <div>
            <div>{{ 'SEARCH_THROUGH' | translate }}</div>
            <div class="sub-title">@if (advanceSearch.search_through_type.taskname && advanceSearch.search_through_type.description && advanceSearch.search_through_type.comment) {
              {{ 'CONTENT_ALL_FIELDS' | translate}}
            } @else {
              @if (advanceSearch.search_through_type.taskname) {
                {{ 'TASK_NAME' | translate}}
                @if (advanceSearch.search_through_type.description || advanceSearch.search_through_type.comment) {
                  ,
                }
              }
              @if (advanceSearch.search_through_type.description) {
                {{ 'DESCRIPTION' | translate}}
                @if (advanceSearch.search_through_type.comment) {
                  ,
                }
              }
              @if (advanceSearch.search_through_type.comment) {
                {{ 'COMMENT' | translate }}
              }
            }
          </div>
        </div>
      </mat-list-item>

      <mat-list-item role="listitem" class="app-container" (click)="redirectTo('create-date-range')">
        <div>
          <div>{{ 'CREATE_DATE_RANGE' | translate }}</div>
          <div class="sub-title">
            @if (advanceSearch.time.type === TimeRangeType.NONE) {
              {{ getTimeRangeObject(TimeRangeType.NONE).translation_key | translate }}
            }
            @if (advanceSearch.time.type === TimeRangeType.LAST_HOUR) {
              {{ getTimeRangeObject(TimeRangeType.LAST_HOUR).translation_key | translate }}
            }
            @if (advanceSearch.time.type === TimeRangeType.LAST_24_HOURS) {
              {{ getTimeRangeObject(TimeRangeType.LAST_24_HOURS).translation_key | translate }}
            }
            @if (advanceSearch.time.type === TimeRangeType.LAST_WEEK) {
              {{ getTimeRangeObject(TimeRangeType.LAST_WEEK).translation_key | translate }}
            }
            @if (advanceSearch.time.type === TimeRangeType.LAST_MONTH) {
              {{ getTimeRangeObject(TimeRangeType.LAST_MONTH).translation_key | translate }}
            }
            @if (advanceSearch.time.type === TimeRangeType.CUSTOM) {
              {{ getTimeRangeObject(TimeRangeType.CUSTOM).translation_key | translate }}
              <span>{{'FROM'|translate}}: {{advanceSearch.time.from.date | vpLocaleDate:medium}}</span>
              <span>{{'TO'|translate}}: {{advanceSearch.time.to.date | vpLocaleDate:medium}}</span>
            }
          </div>
        </div>
      </mat-list-item>
      <mat-list-item role="listitem" class="app-container" (click)="redirectTo('due-date-range')">
        <div>
          <div>{{ 'DUEDATE_RANGE' | translate }}</div>
          <div class="sub-title">
            @if (advanceSearch.dueDateTime.type === DueDateTimeRangeType.NONE) {
              {{ getTimeRangeObject(DueDateTimeRangeType.NONE).translation_key | translate }}
            }
            @if (advanceSearch.dueDateTime.type === DueDateTimeRangeType.LAST_HOUR) {
              {{ getTimeRangeObject(DueDateTimeRangeType.LAST_HOUR).translation_key | translate }}
            }
            @if (advanceSearch.dueDateTime.type === DueDateTimeRangeType.LAST_24_HOURS) {
              {{ getTimeRangeObject(DueDateTimeRangeType.LAST_24_HOURS).translation_key | translate }}
            }
            @if (advanceSearch.dueDateTime.type === DueDateTimeRangeType.LAST_WEEK) {
              {{ getTimeRangeObject(DueDateTimeRangeType.LAST_WEEK).translation_key | translate }}
            }
            @if (advanceSearch.dueDateTime.type === DueDateTimeRangeType.LAST_MONTH) {
              {{ getTimeRangeObject(DueDateTimeRangeType.LAST_MONTH).translation_key | translate }}
            }
            @if (advanceSearch.dueDateTime.type === DueDateTimeRangeType.CUSTOM) {
              {{ getTimeRangeObject(DueDateTimeRangeType.CUSTOM).translation_key | translate }}
              <span>{{'FROM'|translate}}: {{advanceSearch.dueDateTime.from.date | vpLocaleDate:medium}}</span>
              <span>{{'TO'|translate}}: {{advanceSearch.dueDateTime.to.date | vpLocaleDate:medium}}</span>
            }
          </div>
        </div>
      </mat-list-item>

      <mat-list-item role="listitem" class="app-container" (click)="redirectTo('users')">
        <div>
          <div>{{ 'ASSIGNED_TO' | translate }}</div>
          @if (advanceSearch.assignees.type === UserType.NONE) {
            <div class="sub-title">{{ 'NONE' | translate }}</div>
          }
          @if (advanceSearch.assignees.type === UserType.ALL_USERS) {
            <div class="sub-title">{{ 'ALL_USERS' | translate }}</div>
          }
          @if (advanceSearch.assignees.type === UserType.SELECTED) {
            <div class="sub-title">{{ getUsersTitle() }}</div>
          }
        </div>
      </mat-list-item>

      @if (projectList.length > 1) {
        <mat-list-item role="listitem" class="app-container" (click)="redirectTo('projects')">
          <div>
            <div>{{ 'PROJECTS' | translate }}</div>
            @if (advanceSearch.projects.length === 0) {
              <div class="sub-title">{{ 'ALL_PROJECTS' | translate }}</div>
            }
            @if (advanceSearch.projects.length > 0) {
              <div class="sub-title">{{ getProjectsTitle() }}</div>
            }
          </div>
        </mat-list-item>
      }

      <mat-list-item role="listitem" class="app-container" (click)="redirectTo('lists')">
        <div>
          <div>{{ 'LISTS' | translate }}</div>
          @if (advanceSearch.lists.type === ListType.NONE) {
            <div class="sub-title">{{ 'NONE' | translate }}</div>
          }
          @if (advanceSearch.lists.type === ListType.ALL_LISTS) {
            <div class="sub-title">{{ 'ALL_USERS' | translate }}</div>
          }
          @if (advanceSearch.lists.type === ListType.SELECTED) {
            <div class="sub-title">{{ getListsTitle() }}</div>
          }
        </div>
      </mat-list-item>

      <mat-list-item role="listitem" class="app-container" (click)="redirectTo('tags')">
        <div>
          <div>{{ 'TAGS' | translate }}</div>
          @if (advanceSearch.tags.type === TagType.NONE) {
            <div class="sub-title">{{ 'NONE' | translate }}</div>
          }
          @if (advanceSearch.tags.type === TagType.ALL_TAGS) {
            <div class="sub-title">{{ 'ALL_TAGS' | translate }}</div>
          }
          @if (advanceSearch.tags.type === TagType.SELECTED) {
            <div class="sub-title">{{ getTagsTitle() }}</div>
          }
        </div>
      </mat-list-item>

      <mat-list-item role="listitem" class="app-container" (click)="redirectTo('locations')">
        <div>
          <div>{{ 'LOCATIONS' | translate }}</div>
          @if (advanceSearch.locations.type === LocationType.NONE) {
            <div class="sub-title">{{ 'NONE' | translate }}</div>
          }
          @if (advanceSearch.locations.type === LocationType.ALL_LOCATIONS) {
            <div class="sub-title">{{ 'ALL_LOCATIONS' | translate }}</div>
          }
          @if (advanceSearch.locations.type === LocationType.SELECTED) {
            <div class="sub-title">{{ getLocationsTitle() }}</div>
          }
        </div>
      </mat-list-item>

      <mat-list-item role="listitem" class="app-container action-switch">
        <div>
          <div>{{ 'INCLUDE_ATTACHEMENTS' | translate }}</div>
          <div class="sub-title">{{ 'INCLUDE_ATTACHMENTS_SUB_TITLE' | translate }}</div>
        </div>
        <div>
          <vnc-toggle-switch size="s" [checked]="advanceSearch.attachments" (changeEvent)="advanceSearch.attachments = $event.checked; updateSearchOptions();"></vnc-toggle-switch>
        </div>
      </mat-list-item>

      <mat-list-item role="listitem" class="app-container action-switch">
        <div>
          <div>{{ 'INCLUDE_CLOSED_TASKS' | translate }}</div>
          <div class="sub-title">{{ 'INCLUDE_CLOSED_TASKS_SUB_TITLE' | translate }}</div>
        </div>
        <div>
          <vnc-toggle-switch size="s" [checked]="advanceSearch.closed_tasks" (changeEvent)="advanceSearch.closed_tasks = $event.checked; updateSearchOptions();"></vnc-toggle-switch>
        </div>
      </mat-list-item>

      <mat-list-item role="listitem" class="app-container action-switch">
        <div>
          <div>{{ 'SAVE_SEARCHES' | translate }}</div>
          <div class="sub-title">{{ 'SAVE_SEARCHES_SUB_TITLE' | translate }}</div>
        </div>
        <div>
          <vnc-toggle-switch size="s" [checked]="advanceSearch.save_searches" (changeEvent)="advanceSearch.save_searches = $event.checked; updateSearchOptions();"></vnc-toggle-switch>
        </div>
      </mat-list-item>
    </mat-list>
  </div>
</div>
</div>
